import { AnchorHTMLAttributes, ButtonHTMLAttributes, PropsWithChildren } from 'react';
import { styled } from 'styled-components';

interface CommonProps {
	as?: 'a' | 'button';
	className?: string;
}

export type TextLinkProps = PropsWithChildren<
	CommonProps &
		(
			| (AnchorHTMLAttributes<HTMLAnchorElement> & { as?: 'a' })
			| (ButtonHTMLAttributes<HTMLButtonElement> & { as?: 'button' })
		)
>;

const Root = styled.button`
	font-weight: 800;
	font-size: 16px;
	line-height: 20px;
	height: 52px;
	cursor: pointer;
	color: var(--Primary-squla-dark-blue);
	background: transparent;
	border: none;
	padding: 0;

	&:hover {
		text-decoration: underline;
		text-decoration-thickness: 2.5px;
	}
`;

const Visual = styled.span`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 52px;
	border-radius: 40px;
	width: 100%;
	padding: 0 12px;
	gap: 8px;
`;

export function TextLink({ as = 'button', children, ...rest }: TextLinkProps) {
	return (
		<Root as={as} {...rest}>
			<Visual>{children}</Visual>
		</Root>
	);
}

export default TextLink;
